<template>
  <li :class="{ active }">
    <a
      :href="routerLinkTo"
      @click.prevent="select"
    >
      <div class="media">
        <div class="media-body overflow-hidden">
          <div class="d-flex justify-content-between">
            <h5 class="d-flex align-items-center text-truncate font-size-15 mb-1">
              <img
                :src="require(`@/assets/images/channel/${channelName}.png`)"
                class="rounded-circle mr-2"
                style="width: 1rem; height: 1rem;"
                :alt="channelName"
                :title="channelName"
              >
              {{ contactName }}
            </h5>
            <div class="font-size-11 text-nowrap">
              {{ createdAt }}
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <content-rooms-components
              v-if="messageAsLast"
              :is-outgoing="isOutgoing"
              :message-last="messageAsLast"
            />
            <div
              v-if="showCountNewMessages"
              class="unread-message ml-2"
            >
              <span class="badge badge-pill badge-soft-danger">
                {{ room.count_new_messages }}
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-between mb-0 mt-2">
            <status-rooms-components
              :room="room"
              class="mr-2"
            />
            <reassign-with
              class="mb-0 ml-2"
              :room="room"
            >
              <template v-slot:before>
                <i class="ri-user-fill mr-1" />
              </template>
            </reassign-with>
          </div>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {
  ChatStatusChat,
  ChatStatusNew,
  ChatStatusResolved,
  EmitterClient,
  TypeIncoming,
  TypeOutgoing,
} from "../../../services/chat/const";
import dateTimeSameHuman from '../../../utils/dateTimeSameHuman';
import contactName from "../../../utils/contactName";
import ReassignWith from "../../Room/Header/WithHeaderRoomComponents";
import ContentRoomsComponents from "./Helpers/ContentRoomsComponents";
import StatusRoomsComponents from "./Helpers/StatusRoomsComponents";

const statusIcon = {
  [ChatStatusNew]: 'ri-arrow-right-line',
  [ChatStatusChat]: 'ri-message-3-line',
  [ChatStatusResolved]: 'ri-check-fill',
}

export default {
  name: 'RoomOne',
  components: {
    StatusRoomsComponents,
    ContentRoomsComponents,
    ReassignWith,
  },
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('rooms', [
      'rooms',
      'selectedRoomId',
    ]),
    ...mapState('room', [
      'messageIdSearch',
    ]),
    ...mapGetters('rooms', [
      'searchMod',
    ]),

    room() {
      return this.rooms[this.source.id];
    },
    messageAsLast() {
      if (this.searchMod && this.source.message_query) {
        return this.source.message_query;
      }
      return this.room.message_last;
    },
    routerLinkTo() {
      return (
        `/chat/${this.source?.id}` +
        (this.searchMod ? `#${this.messageAsLast?.id}` : '')
      );
    },
    isEmitterClient() {
      return this.messageAsLast?.emitter === EmitterClient;
    },
    type() {
      if (this.isEmitterClient) {
        return TypeIncoming;
      } else {
        return TypeOutgoing;
      }
    },
    isIncoming() {
      return this.type === TypeIncoming;
    },
    isOutgoing() {
      return this.type === TypeOutgoing;
    },

    active() {
      if (this.searchMod && this.source.message_query) {
        return this.messageIdSearch === this.source.message_query.id;
      }
      return this.selectedRoomId === this.room.id;
    },
    showCountNewMessages() {
      return (
        !this.searchMod &&
        this.room &&
        !!this.room.count_new_messages
      );
    },
    statusIcon() {
      return statusIcon[this.room.status] || '';
    },
    channelName() {
      return this.room.channel_name.toLowerCase();
    },
    contactName() {
      return contactName(this.room);
    },
    createdAt() {
      return dateTimeSameHuman.call(this, this.messageAsLast?.created_at);
    },
  },
  methods: {
    select() {
      const {id: chat_id} = this.room;
      const {id: message_id} = this.searchMod && this.source.message_query;
      this.$store.dispatch('room/goto', {chat_id, message_id});
    },
  },
}
</script>
